import React, { useRef } from 'react';

import {
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

import { useNews } from '../components/NewsContext';

import useNewsArticle from '../hooks/useNewsArticle';
import useNewsViews from '../hooks/useNewsViews';
import useNewsAuthor from '../hooks/useNewsAuthor';
import useNewsEngagement from '../hooks/useNewsEngagement';

import NewsSeo from '../components/news-details/NewsSeo';
import NewsHeader from '../components/news-details/NewsHeader';
import NewsContent from '../components/news-details/NewsContent';
import NewsMeta from '../components/news-details/NewsMeta';
import SocialLinks from '../components/SocialLinks';

import Comments from './Comments';
import CommentForm from './CommentForm';

import RelatedNewsSlider from '../sections/RelatedNewsSlider';

import '../styles/NewsDetails.css';
import defaultBackground from '../img/news-background.jpg';

const NewsDetails = () => {
  const {
    newsList,
    firstLoadDone,
  } = useNews();

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    news,
    loading,
    error,
  } = useNewsArticle(
    id,
    newsList
  );

  const views =
    useNewsViews(news);

  const authorProfile =
    useNewsAuthor(news);
  const authorId =
    authorProfile?.id ||
    news?.authorId ||
    null;
  const articleRef = useRef(null);
  useNewsEngagement(news, articleRef);

  const handleGoBack = () => {
    if (location.state?.from) {
      navigate(
        location.state.from
      );

      return;
    }

    navigate(-1);
  };

  const handleTagClick = (tag) => {
    navigate(
      `/search?q=${encodeURIComponent(tag)}`
    );
  };

  if (
    loading &&
    !firstLoadDone
  ) {
    return (
      <p>Завантаження новини...</p>
    );
  }

  if (loading) {
    return (
      <p>Завантаження новини...</p>
    );
  }

  if (!news) {
    return (
      <p>
        {error ||
          'Новина не знайдена'}
      </p>
    );
  }

  return (
    <>
      <NewsSeo
        news={news}
        authorId={authorId}
      />

      <div
        className="single-news-container"
        style={{
          backgroundImage:
            `url(${defaultBackground})`,
        }}
      >
        <div className="news-page-layout">
          <aside
            className="news-social-sidebar"
            aria-label="Соціальні мережі BigSport"
          >
            <SocialLinks
              orientation="vertical"
              size="sm"
              className="news-social-links"
              placement="news_sidebar"
            />
          </aside>

          <main className="news-page-main">
            <NewsHeader
              title={news.title}
              onGoBack={handleGoBack}
            />

            <div className="single-news-content-wrapper" ref={articleRef}>
              <NewsContent
                news={news}
                onTagClick={
                  handleTagClick
                }
              />

              <NewsMeta
                news={news}
                authorProfile={authorProfile}
                views={views}
              />
            </div>

            <RelatedNewsSlider
              currentNews={news}
              newsList={newsList}
            />

            <CommentForm
              newsId={news.id}
              category={news.category}
            />

            <Comments
              newsId={news.id}
            />
          </main>
        </div>
      </div>
    </>
  );
};

export default NewsDetails;
